import { render } from "./market-bids-block.vue?vue&type=template&id=6cd126b7&scoped=true"
import script from "./market-bids-block.vue?vue&type=script&lang=js"
export * from "./market-bids-block.vue?vue&type=script&lang=js"

import "./market-bids-block.vue?vue&type=style&index=0&id=6cd126b7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd126b7"]])

export default __exports__